import React, { ReactNode, useEffect } from 'react';
import './styles.less';
import { CloseButton } from '../CustomIcons/CloseButton/web';
import { createPortal } from 'react-dom';

interface ModalProps {
    show: boolean;
    width?: string;
    height?: string;
    background?: string;
    title?: string | ReactNode;
    footer?: ReactNode;
    showHeader?: boolean;
    children: React.ReactNode;
    onClose: () => void;
    classes?: string
    customIndex?: number
    bodyStyles?: React.CSSProperties;
    backdropStyles?: React.CSSProperties;
    containerStyles?: React.CSSProperties;
    animation?: 'fade' | 'slide';
}

export const Modal: React.FC<ModalProps> = ({ show, width, height, background, title, children, onClose, footer, classes, bodyStyles, backdropStyles, showHeader = true, customIndex, containerStyles }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (show) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [show]);

    const handleClose = () => {
        onClose();
    };

    const handleBackdropClick = (event: React.MouseEvent) => {
        if (event.target === event.currentTarget) {
            handleClose();
        }
    };

    const modalStyle = {
        width: width || 'auto',
        height: height || 'auto',
        ...containerStyles
    };

    return show ? createPortal(
        <div 
            className={`modal-backdrop modal-open`} 
            style={{ ...backdropStyles, zIndex: customIndex ?? 999 }}
            onClick={handleBackdropClick}
        >
            <div className={"modal " + (background == 'transparent ' ? 'modal-transparent ' : '') + (classes ?? "")} style={modalStyle}
            >
                {showHeader && (<div className="modal-header">
                    <div className="modal-title">{title}</div>
                    <button className={"close-button " + (background == 'transparent' ? 'button-background' : '')} onClick={handleClose}>
                        <CloseButton />
                    </button>
                </div>)}
                <div className="modal-body" style={bodyStyles ?? {}}>
                    {children}
                </div>

                {footer && <div className="modal-footer">
                    {footer}
                </div>}
            </div>
        </div>,
        document.body
    ) : null;
};
